import { useEffect } from 'react'

import isBrowser from '@src/quince-site-common/src/utils/isBrowser'

export function useBodyNoScroll(hideScroll: boolean) {
  useEffect(() => {
    if (isBrowser() && hideScroll) {
      document.body.classList.add('forceNoScroll')
    }
    return () => {
      document.body.classList.remove('forceNoScroll')
    }
  }, [hideScroll])
}
